type RotatingBadgeProps = {
  text: string;
  size?: number;
  className?: string;
};

export default function RotatingBadge({ text, size = 104, className = '' }: RotatingBadgeProps) {
  const chars = text.split('');
  const radius = size / 2 - 14;

  return (
    <div
      className={`relative select-none ${className}`}
      style={{ width: size, height: size }}
    >
      <div className="absolute inset-0 animate-spin-slow">
        {chars.map((ch, i) => {
          const angle = (360 / chars.length) * i;
          return (
            <span
              key={i}
              className="absolute left-1/2 top-1/2 font-label text-[10px] tracking-[0.22em] uppercase text-foreground-700"
              style={{ transform: `rotate(${angle}deg) translateY(-${radius}px)` }}
            >
              {ch}
            </span>
          );
        })}
      </div>

      <div className="absolute inset-0 flex items-center justify-center">
        <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-foreground-950">
          <i className="ri-arrow-down-line text-base w-4 h-4 flex items-center justify-center" />
        </span>
      </div>
    </div>
  );
}